import { Box, Popper, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { PersonIcon } from '@/shared/ui/Icons'
import { SettingsPopper } from '@/features/Settings/ui/components/SettingsPopper'
import { useAppStore } from '@/shared/store'
import { useFetchAndSetProfiles } from '../lib'
import { isStreamIQ } from '@/shared/lib'

const ProfileMenu = (): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined
    const { setProfiles, isUserLoggedIn, profiles } = useAppStore()
    const theme = useTheme()

    const ref = useRef<HTMLDivElement | null>(null)

    const { fetchAndSetProfiles } = useFetchAndSetProfiles(() => setProfiles)
    const handlePopperClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()

        if (!open) {
            setAnchorEl(event.currentTarget)
        } else {
            setAnchorEl(null)
        }
    }

    useEffect(() => {
        if (anchorEl) {
            fetchAndSetProfiles()
        }
    }, [anchorEl])

    useEffect(() => {
        const id = setTimeout(() => {
            if (isStreamIQ() && !profiles.length && isUserLoggedIn) {
                setAnchorEl(ref.current)
            }
        }, 300)
        return () => clearTimeout(id)
    }, [profiles.length, isUserLoggedIn])

    const handlePopperClose = () => {
        setAnchorEl(null)
    }

    const popperOffset = [42, 12]

    const popperContainerStyle = {
        width: '250px',
        height: 'max-content',
        padding: '16px',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: 'custom.dropDownBackground',
        zIndex: 9,
        boxShadow: '0px 4px 20px 0px #0000004D',
    }
    const profileImageStyle = {
        height: '41px',
        borderRadius: '50%',
        '&:hover': {
            cursor: 'pointer',
        },
        ml: '25px',
        mt: '5px',
    }
    const popperModifiers = [
        {
            name: 'offset',
            options: {
                offset: popperOffset,
            },
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 30,
                boundariesElement: 'viewport',
            },
        },
    ]

    return (
        <ClickAwayListener onClickAway={handlePopperClose}>
            <Box position="relative">
                <Box
                    ref={ref}
                    sx={profileImageStyle}
                    onClick={isUserLoggedIn ? handlePopperClick : () => null}>
                    <PersonIcon />
                </Box>
                <Popper
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    sx={popperContainerStyle}
                    placement="bottom-end"
                    modifiers={popperModifiers}>
                    <SettingsPopper onClose={handlePopperClose} />
                </Popper>
            </Box>
        </ClickAwayListener>
    )
}
export { ProfileMenu }
